import Svg from 'components/utilities/svg'

const CircleIcon = ({ ...props }) => (
  <Svg viewBox="0 0 24 24" {...props}>
    <title>Circle Icon</title>
    <path d="M12,19 C11.0316667,19 10.1216667,18.8161333 9.27,18.4484 C8.41833333,18.0811333 7.6775,17.5825 7.0475,16.9525 C6.4175,16.3225 5.91886667,15.5816667 5.5516,14.73 C5.18386667,13.8783333 5,12.9683333 5,12 C5,11.0316667 5.18386667,10.1216667 5.5516,9.27 C5.91886667,8.41833333 6.4175,7.6775 7.0475,7.0475 C7.6775,6.4175 8.41833333,5.91863333 9.27,5.5509 C10.1216667,5.18363333 11.0316667,5 12,5 C12.9683333,5 13.8783333,5.18363333 14.73,5.5509 C15.5816667,5.91863333 16.3225,6.4175 16.9525,7.0475 C17.5825,7.6775 18.0811333,8.41833333 18.4484,9.27 C18.8161333,10.1216667 19,11.0316667 19,12 C19,12.9683333 18.8161333,13.8783333 18.4484,14.73 C18.0811333,15.5816667 17.5825,16.3225 16.9525,16.9525 C16.3225,17.5825 15.5816667,18.0811333 14.73,18.4484 C13.8783333,18.8161333 12.9683333,19 12,19 Z" />
  </Svg>
)

CircleIcon.displayName = 'Circle'

export default CircleIcon
